import { render, staticRenderFns } from "./SegmentacaoClientes.vue?vue&type=template&id=3eefcfa6&scoped=true&"
import script from "./SegmentacaoClientes.vue?vue&type=script&lang=js&"
export * from "./SegmentacaoClientes.vue?vue&type=script&lang=js&"
import style0 from "./SegmentacaoClientes.vue?vue&type=style&index=0&id=3eefcfa6&scoped=true&lang=css&"
import style1 from "./SegmentacaoClientes.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eefcfa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VRow})
